import { PlotColumnOptions } from "highcharts";

export const stackedColumnChartPlotOptionsColumn: PlotColumnOptions = {
  stacking: "normal",
  borderWidth: 0,
  groupPadding: 0.1,
  pointPadding: 0.05,
};
